// TEMPORAL -- solo para la prueba manual de Auth0 Organizations (ver conversacion: si el
// claim "permissions" del Access Token cambia segun la organizacion, o si hace falta una
// Action custom). El pedido de token manual pegando el URL de /authorize con
// response_type=token se estaba perdiendo en el redirect (el hash #access_token=... no
// llegaba a verse antes de que algo lo pisara), asi que esto evita esa carrera por
// completo: usa getAccessTokenWithPopup del SDK de Auth0 (abre un popup, hace el login
// ahi adentro, y devuelve el token directo como valor de JS a la consola) en vez de
// navegar la pestaña principal.
//
// Como useAuth0() es un hook y no se puede llamar desde la consola del navegador
// directamente, este componente (montado una sola vez, como hermano de <App /> dentro del
// mismo <Auth0Provider>, ver index.jsx) expone las funciones que hacen falta en
// window.__auth0Debug, listas para usar desde devtools.
//
// Borrar este archivo y su <Auth0DebugTokenExposer /> en index.jsx una vez terminada la
// prueba de Organizations -- no tiene que quedar en produccion.
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const Auth0DebugTokenExposer = () => {
    const { getAccessTokenWithPopup, getAccessTokenSilently, loginWithRedirect } = useAuth0();

    useEffect(() => {
        // Sin console.log de aviso (a pedido, se quito toda impresion informativa del
        // dashboard) -- window.__auth0Debug queda igual disponible para probar a mano
        // desde devtools, ej.:
        // await window.__auth0Debug.getAccessTokenWithPopup({ authorizationParams: { audience: "https://api.hawk.internal", organization: "org_aL2ddGMcr10zdyO6" } })
        window.__auth0Debug = { getAccessTokenWithPopup, getAccessTokenSilently, loginWithRedirect };
    }, [getAccessTokenWithPopup, getAccessTokenSilently, loginWithRedirect]);

    return null;
};

export default Auth0DebugTokenExposer;
